import { z } from 'zod/mini';
import { listSearchSchema } from '../list/search/list-search-schema';
import type { jobsQueryFragment$data } from './__generated__/jobsQueryFragment.graphql';

type TJobKeys = keyof jobsQueryFragment$data['content'][number];

export const jobsSearchSchema = z.intersection(
    listSearchSchema,
    z.object({
        sortBy: z.optional(
            z.catch(z.enum<TJobKeys[]>(['name', 'group', 'jobClass', 'description']), 'name')
        ),
    })
);

export type TJobsSearchSchema = z.infer<typeof jobsSearchSchema>;
